import type { ChordProgression } from '@/types/music';

/** Ready-made chord chains a beginner can actually use in real songs. */
export const PROGRESSIONS: ChordProgression[] = [
  {
    id: 'pop-1564',
    nameRu: 'Поп-четвёрка',
    chordIds: ['C', 'G', 'Am', 'F'],
    hintRu: 'На ней держится половина популярных песен',
  },
  {
    id: 'folk-1546',
    nameRu: 'Дворовая',
    chordIds: ['G', 'D', 'Em', 'C'],
    hintRu: 'Та же четвёрка, но без баррэ',
  },
  {
    id: 'minor-6415',
    nameRu: 'Грустная',
    chordIds: ['Am', 'F', 'C', 'G'],
    hintRu: 'Начинается с минора — звучит задумчиво',
  },
  {
    id: 'minor-easy',
    nameRu: 'Совсем простая',
    chordIds: ['Em', 'C', 'G', 'D'],
    hintRu: 'Четыре аккорда без единого баррэ',
  },
  {
    id: 'first-pair',
    nameRu: 'Первая пара',
    chordIds: ['Am', 'C'],
    hintRu: 'Меняется одним пальцем — с неё начинают',
  },
  {
    id: 'em-am',
    nameRu: 'Два минора',
    chordIds: ['Em', 'Am'],
    hintRu: 'Оба лёгкие, переход короткий',
  },
];

export function getProgression(id: string): ChordProgression | undefined {
  return PROGRESSIONS.find((p) => p.id === id);
}
